/*
 * @Author: yanghailong
 * @Date: 2023-08-23 09:07:27
 * @Last Modified by: yanghailong
 * @Last Modified time: 2025-04-10 20:13:18
 */

import Konva from "konva"
import { AddObjectRecord } from "../history/record.js"
import { GraphElement } from "../graph-element.js"
import { LinkPoint } from "../link-point.js"
import { Property } from "./property.js"
// import { mixin } from "../utils/index.js"
import { Configs } from "../data.js"

/**
 * @class 方阵内部元素
 * @param {import('../topology.js').Topology} topology 拓扑实例
 * @param {number} [x=0] 初始x
 * @param {number} [y=0] 初始y
 */
class SquareInnerElement extends Property {
  constructor(topology, x = 0, y = 0) {
    super()

    this.topology = topology

    this.g = new Konva.Group({
      x: x,
      y: y
    })

    // Property.call(this)

    this.prop_x = -60
    this.prop_y = -10
    this.prop_h = 20

    //
    this.name = null
    this.sort = null
    this.deviceUUID = null
    //
    this.breakerState = null
  }


  updateBreakerState(state) {
    this.state = state;
    if (state) {
      this.breakerRect.setAttr("fill", "F73046")
    } else {
      this.breakerRect.setAttr("stroke", "#3BB74F")
      this.breakerRect.setAttr("fill", rgba(0,0,0,0))
    }
    // let colors = ['#3BB74F', '#f00']
    // let c = colors[state] || '#3BB74F'
    // this.breakerRect.setAttr('stroke', c)
    this.breakerState = state
  }

  getBreakerState() {
    return this.breakerState
  }


  addToGroup(g) {
    g.add(this.g)
  }

  remove() {
    this.g.remove()
  }

  toJSON() {
    return {
      name: this.name,
      sort: this.sort,
      deviceUUID: this.deviceUUID,
    }
  }

  setData(name, sort, deviceUUID) {
    this.name = name
    this.sort = sort
    this.deviceUUID = deviceUUID
    if (this.nameLabel) {
      this.nameLabel.setText(name)
    }
  }
}

// mixin(SquareInnerElement.prototype, Property.prototype)


/**
 * @class 方阵内部的eLink
 * @param {import('../topology.js').Topology} topology 拓扑实例
 * @param {string} name 名称
 */
class SquareELink extends SquareInnerElement {
  constructor(topology, name) {
    super(topology)
    this.name = name
    this.sort = null
    this.deviceUUID = null
    this.setup()
  }

  setup() {
    this.#addELinkRect()
    this.#addNameLabel()
    this.#addVerticalLineSegment()
    this.#addBreakerRect()


    this.addProperty('电压', 'V')
    this.addProperty('电流', 'A')
    this.addProperty('功率', 'kW')
  }

  #addELinkRect() {
    this.eLinkRect = new Konva.Rect({
      x: 0,
      y: 0,
      width: 100,
      height: 30,
      stroke: '#000',
      strokeWidth: 1,
    })

    this.g.add(this.eLinkRect)
  }

  #addNameLabel() {
    let w = this.eLinkRect.width()// - this.name.length * 6
    let h = this.eLinkRect.height()// - 14
    this.nameLabel = new Konva.Text({
      width: w,
      height: h,
      x: 0,
      y: 0,
      text: this.name,
      align: 'center',
      verticalAlign: 'middle',
      fill: '#000',
    })

    this.g.add(this.nameLabel)
  }

  #addBreakerRect() {
    let width = 20
    let height = 35
    let w = this.eLinkRect.width() - width
    let h = this.eLinkRect.height()
    this.breakerRect = new Konva.Rect({
      x: w / 2,
      y: h + 20,
      width: width,
      height: height,
      // stroke: '#3BB74F',
      fill: '#F73046',
      strokeWidth: 2,
    })
    this.g.add(this.breakerRect)

    this.breakerRect.on('dblclick', event => {

      this.topology.dispatchEvent({
        type: 'topo:breakerSelected',
        detail: {
          deviceType: 'eLink',
          deviceUUID: this.deviceUUID,
          breakerState: this.getBreakerState()
        }
      })
    })
  }

  #addVerticalLineSegment() {
    let w = this.eLinkRect.width()
    let h = this.eLinkRect.height()
    this.vLine = new Konva.Rect({
      x: w / 2,
      y: h,
      width: 0,
      height: 115,
      stroke: Configs.edgeColor,
      fill: Configs.edgeColor,
    })
    this.g.add(this.vLine)
  }
}


/**
 * @class 方阵内部的eBlock
 * @param {import('../topology.js').Topology} topology 拓扑实例
 * @param {number} x 位置x
 * @param {number} y 位置y
 * @param {string} name 名称
 * @param {string} sort 序号
 * @param {string} uuid uuid
 */
class SquareEBlock extends SquareInnerElement {
  constructor(topology, x, y, name, sort, uuid) {
    super(topology, x, y)
    this.name = name
    this.sort = sort
    this.deviceUUID = uuid

    // 重新设置属性起始位置
    this.prop_x = 0
    this.prop_y = 210
    // this.g.offsetX(-26)
    this.setup()
  }

  setup() {
    this.#addEBlockRect()
    this.#addNameLabel()
    this.#addVerticalLineSegment()
    this.#addBreakerRect()


    this.addProperty('电压', 'V')
    this.addProperty('电流', 'A')
    this.addProperty('功率', 'kW')
    this.addProperty('SOC', '%', { fill: 'rgb(44, 213, 99)' })
  }

  #addEBlockRect() {
    this.eBlockRect = new Konva.Rect({
      x: 0,
      y: 120,
      width: 50,
      height: 80,
      stroke: '#000',
      strokeWidth: 1,
    })

    this.g.add(this.eBlockRect)
  }

  #addNameLabel() {
    let w = this.eBlockRect.width()// - this.name.length * 6
    let h = this.eBlockRect.height()// - 14
    this.nameLabel = new Konva.Text({
      width: w,
      height: h,
      x: 0,
      y: 120,
      text: this.name,
      align: 'center',
      verticalAlign: 'middle',
      fill: '#000',
    })

    this.g.add(this.nameLabel)
  }

  #addBreakerRect() {
    let width = 20
    let height = 35
    let w = this.eBlockRect.width() - width
    let h = this.eBlockRect.height()
    this.breakerRect = new Konva.Rect({
      x: w / 2,
      y: 50,
      width: width,
      height: height,
      // stroke: '#3BB74F',
      fill: '#F73046',
      strokeWidth: 2,
    })
    this.g.add(this.breakerRect)

    this.breakerRect.on('dblclick', event => {
      this.topology.dispatchEvent({
        type: 'topo:breakerSelected',
        detail: {
          deviceType: 'eBlock',
          deviceUUID: this.deviceUUID,
          breakerState: this.getBreakerState()
        }
      })
    })
  }

  #addVerticalLineSegment() {
    let w = this.eBlockRect.width()
    let h = this.eBlockRect.height()
    this.vLine = new Konva.Rect({
      x: w / 2,
      y: 0,
      width: 0,
      height: 120,
      stroke: '#F73046',
      fill: '#F73046',
    })
    this.g.add(this.vLine)
  }
}



/**
 * @class 储能方阵
 */
class SquareElement extends GraphElement {
  constructor(topology, x, y, attrs) {
    super(topology, 'square', x, y, { width: 100, height: 30, port: true })

    // eBlock相关数据
    this.eBlocks = []
    this.eBlockVisible = true
    this.eBlockOffset = 0
    this.eBlockOffsetPercentage = 0
  }


  setup(name, attrs) {
    this.addKeyshape(name, attrs)
    // onload
    this.addPort(attrs.port)
    this.addLabel(attrs.text)
    this.addTransformer()

    this.addELink()
    this.addLinkPoint()
    this.addSubBus()
    this.executeLoadedHook(this.keyShape)
  }

  addKeyshape(name, attrs) {
    this.keyShape = new Konva.Rect({
      x: 0,
      y: 0,
      width: attrs.width,
      height: attrs.height,
      // stroke: '#782674',
      strokeWidth: 1,
      isKeyShape: true,
      name: `${name}-img`,
    })

    this.g.add(this.keyShape)
  }

  //#region 储能方阵中的元素
  addELink() {
    this.eLink = new SquareELink(this.__topology, '1#eLink')
    this.g.add(this.eLink.g)
  }

  addEBlock(eBData, ebIndex) {
    let sort = eBData.sort
    // let ebName = sort + '#' + eBData.eBlockName
    let ebName = eBData.eBlockName
    let x = 100 * ebIndex + this.eBlockOffset
    let y = 150
    let eb = new SquareEBlock(this.__topology, x, y, ebName, eBData.sort, eBData.uuid)
    eb.addToGroup(this.g)
    this.eBlocks.push(eb)
  }

  addLinkPoint() {
    this.linkPoint = new LinkPoint(this.__topology, 40, 112, 0)
    this.g.add(this.linkPoint.g)

    this.linkPoint.g.on('state-change', (event) => {
      console.log('state change')
      this.eBlockVisible = event.state
      this.updateEBlocksVisible()
      this.updateSubBusState()

      // 关闭其他方阵
      this.__topology.storage.displayElement.forEach(ge => {
        if (ge instanceof SquareElement && ge !== this) {
          ge.linkPoint.setState(0)
          ge.eBlockVisible = false
          ge.updateEBlocksVisible()
          ge.updateSubBusState()
        }
      })
    })
  }

  addSubBus() {
    this.subBus = new Konva.Rect({
      x: this.eBlockOffset,
      y: this.linkPoint.y + 32,
      width: 0,
      height: 6,
      fill: '#F73046',
    })
    this.g.add(this.subBus)
  }
  updateSubBusState() {
    this.updateSubBusWidth()
    this.updateSubBusVisible()
    this.updateELinkVLine()
  }
  updateSubBusWidth() {
    this.subBus.setAttr('width', 100 * this.eBlocks.length)
  }
  updateSubBusVisible() {
    if (this.eBlockVisible) {
      this.subBus.show()
    } else {
      this.subBus.hide()
    }
  }
  updateELinkVLine() {
    if (this.eBlockVisible) {
      this.eLink.vLine.setAttr('height', 115)
    } else {
      this.eLink.vLine.setAttr('height', 80)
    }
  }
  /**
   * 更新eB显示状态
   */
  updateEBlocksVisible() {
    this.eBlocks.forEach(sqEB => {
      if (this.eBlockVisible) {
        sqEB.g.show()
      } else {
        sqEB.g.hide()
      }
    })
  }

  //#endregion

  setData(data) {
    // 设置 eLink
    this.eLink.setData(data.eLinkName, data.sort, data.uuid)

    this.removeEBlocks()
    // 根据数据创建eBlock
    for (let i = 0; i < data.eBlocks.length; i++) {
      const eB = data.eBlocks[i]
      this.addEBlock(eB, i)
    }
    this.updateEBlocksVisible()
    this.updateSubBusState()
  }

  updateData(data, dataObject) {
    this.eLink.updateProperty('电压', data.u_a)
    this.eLink.updateProperty('电流', data.i_a)
    this.eLink.updateProperty('功率', data.p_total)
    this.eLink.updateBreakerState(data.ac_qf_st)

    this.eBlocks.forEach(sqEB => {
      let realdata = dataObject[sqEB.deviceUUID] || {}
      // console.log('realdata', realdata, sqEB)
      sqEB.updateProperty('电压', realdata.u_dc)
      sqEB.updateProperty('电流', realdata.i_dc)
      sqEB.updateProperty('功率', realdata.p_dc)
      sqEB.updateProperty('SOC', realdata.soc)
      sqEB.updateBreakerState(realdata.ac_qf_st)
    })
  }

  updateEBlockOffsetPercentage(percentage = 0) {
    const maxWidth = 1400
    const offsetX = (percentage / 100) * maxWidth
    this.eBlockOffsetPercentage = percentage
    this.eBlockOffset = -offsetX
    this.updateOffset()
  }

  updateOffset() {
    //
    this.eBlocks.forEach((sqEB, ebIndex) => {
      let x = 100 * ebIndex + this.eBlockOffset
      sqEB.g.setAttr('x', x)
    })
    this.subBus.setAttr('x', this.eBlockOffset)
  }


  removeEBlocks() {
    // 移除原来的eBlock
    this.eBlocks.forEach(sqEB => {
      sqEB.remove()
    })

    this.eBlocks = []
  }

  /**
   * 返回该图形的JSON描述
   */
  toJSON() {

    const { eBlockVisible, eBlocks, eLink, eBlockOffsetPercentage } = this
    const eLinkDesc = eLink.toJSON()
    const eBlocksDesc = eBlocks.map(sqEB => sqEB.toJSON())

    return {
      eLinkDesc,
      eBlocksDesc,
      eBlockVisible,
      eBlockOffsetPercentage,
      ...super.toJSON(),
    }

  }

  /**
   * 从JSON描述创建方阵
   * @param {import('./topology.js').Topology} topology 拓扑图对象
   * @param {object} node 数据
   * @param {Function} complete 完成回调
   */
  static fromJSON(topology, node, complete) {
    return new Promise((resolve) => {
      let elem = new this(topology, node.attrs.x, node.attrs.y)
      // elem.keyShape.setAttrs(node.keyShapeAttrs)
      // elem.updateLabelPosition()
      // set  uuid
      elem.uuid = node.uuid
      elem.deviceUUID = node.deviceUUID

      elem.label.setAttr('text', node.label)

      // set port uuid
      elem.ports.portDown.setAttr('uuid', node.ports.portDown)
      elem.ports.portUp.setAttr('uuid', node.ports.portUp)

      // 设置eLink数据
      const { name, sort, deviceUUID } = node.eLinkDesc
      elem.eLink.setData(name, sort, deviceUUID)

      // 生成eBlock
      // 移除原来的eBlock
      elem.eBlocks.forEach(sqEB => {
        sqEB.remove()
      })
      elem.eBlocks = []
      // 根据数据创建eBlock
      for (let i = 0; i < node.eBlocksDesc.length; i++) {
        const eBDesc = node.eBlocksDesc[i]
        const { name, sort, deviceUUID } = eBDesc
        let x = 100 * i
        let y = 150
        let sqEB = new SquareEBlock(topology, x, y, name, sort, deviceUUID)
        sqEB.addToGroup(elem.g)
        elem.eBlocks.push(sqEB)
      }
      // 设置eBlock展开状态
      elem.eBlockVisible = node.eBlockVisible
      elem.linkPoint.setState(node.eBlockVisible)
      elem.updateEBlocksVisible()
      elem.updateSubBusState()

      // 设置eBlock偏移
      elem.updateEBlockOffsetPercentage(node.eBlockOffsetPercentage)

      // add element
      topology.storage.addElement(elem)
      topology.history.push(new AddObjectRecord(topology, elem))

      complete && complete()
      resolve(elem)
    })

  }
}

export { SquareElement }
